/* istanbul ignore file */

import BasicResources from './basic-resources';
import { Credentials } from '../types/common.types';

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.

// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
class Resources {
    /* istanbul ignore file */
    // createResources() should create a static field for each resource:
    //
    //    const env = parentEnv || Resources.env;
    //
    //    Resources.colours = env.resource('Colours')
    //                           .baseUrl('@AvatarAdminBaseUrl')
    //                           .service('colours');
    //
    //
    // Application code can then access those resources like so:
    //
    //    const allColours = Resource.colours.get().send();
    //

    static env?: any;
    static getConfigurationItem: any;
    static getToken: any;

    static schoolAcademicYearsSearch?: any;
    static schoolAcademicYearsPut?: any;

    static createResources(parentEnv?: any) {
        if (parentEnv) {
            Resources.env = parentEnv;
        }
        const { env } = Resources;

        // Config manager names:
        const BASE_URL = '@SchoolAcademicYearGatewayEndpoint';
        const AUTHENTICATION_URL = '@AuthenticationGatewayEndpoint';

        Resources.getConfigurationItem = async (key: string) => {
            try {
                return await env.getConfigurationItem(key);
            } catch (error) {
                console.error('Retrieving configuration failed. Please check you actually have a config key called "' +
                    key + '" in app named "' + env.application + '" in Config for environment "' + env.name + '".');
            }
        }

        // STATIC PROPERTIES FOR EACH RESOURCES

        Resources.getToken = Resources.env.resource('sessions')
            .baseUrl(AUTHENTICATION_URL)
            .service('/sessions');

        Resources.schoolAcademicYearsSearch = env.resource('schoolAcademicYearsSearch')
            .baseUrl(BASE_URL)
            .service('/school-academic-years/search');

        Resources.schoolAcademicYearsPut = env.resource('schoolAcademicYearsPut')
            .baseUrl(BASE_URL)
            .service('/school-academic-years');
    }

    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.

    static initialise(envName: string, credentials: Credentials) {
        Resources.env = BasicResources.initialise(envName, credentials);

        Resources.createResources();

        return Resources.env;
    }
}

export default Resources;
